import PropTypes from 'prop-types'

// MUI ThemeProvider is no longer needed — Tailwind handles theming via tailwind.config.js
export const AdasThemeProvider = ({ children }) => <>{children}</>

AdasThemeProvider.propTypes = { children: PropTypes.node }
